const submissionTaskStatus = {
    ALL : -1,

    ASSIGNED : 0,

    RESOLVED : 1

};

angular.module('gw-um-j2js')
    .constant('submissionTaskStatus', submissionTaskStatus);